import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map, retry } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';
// import { Category } from './template-category.model';
import { TemplateTop5 } from './template-top5.model';
import { Template } from './template.model';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  private apiUrl = '/api/templates';

  constructor(
    public authService: AuthService,
    public http: HttpClient
  ) { }

  getTemplateListByProvider(provider: string): Observable<Template[]> {
    return this.http.get<Template[]>(`${this.apiUrl}/provider/${provider}`)
      .pipe(
        retry(3),
        map(templates => templates),
        catchError(this.errorHandler)
      )
  }

  // TODO: ggf. löschen, wenn die neue obige Lösung in Zusammenhang mit der Verarbeitung des Ergebnisses im Template funktionert.
  // getTemplateListByProvider(provider: string): Observable<Category[]> {
  //   return this.http.get<Template[]>(`${this.apiUrl}/provider/${provider}`)
  //     .pipe(
  //       retry(3),
  //       // extract categories
  //       map(templates => {
  //         const categories = templates.map(template => template.category)
  //           .filter((category, index, array) => array.indexOf(category) === index);
  //         return categories.map(category => { 
  //           return {
  //             category: category,
  //             templates: templates.filter(template => template.category === category)
  //           };
  //         });
  //       }),
  //       catchError(this.errorHandler)
  //     )
  // }

  getTemplateListTop5(): Observable<TemplateTop5[]> {
    return this.http.get<TemplateTop5[]>(`${this.apiUrl}/top5`)
      .pipe(
        retry(3),
        map(result => result),
        catchError(this.errorHandler)
      )
  }

  // getTemplateListByUserGroup(usergroup: string): any {
  //   return this.http.get(`${this.apiUrl}/${usergroup}`)
  //     .pipe(
  //       retry(3),
  //       map(
  //           result => result
  //       ),
  //       // filter(result => (result['category'] === 'Allgemein'))
  //     ),
  //     catchError(this.errorHandler
  //   );
  // }


  ////


  getTemplates(): Observable<Template[]> {
    return this.http.get<Template[]>(this.apiUrl)
      .pipe(
        retry(3),
        map(
          result => result
        ),
        catchError(this.errorHandler)
      );
  }

  getTemplate(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  postTemplate(template: Template): Observable<any> {
    const _id = this.authService.getUserId();
    const templateAndOwnerId = {
      owner: _id,
      ...template,
    };
    return this.http.post(this.apiUrl, templateAndOwnerId);
  }

  updateTemplate(template: Template): Observable<any> {
    return this.http.post(`${this.apiUrl}/${template._id}/edit`, { template });
  }

  deleteTemplate(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  private errorHandler(error: HttpErrorResponse): Observable<any> {
    console.error('Fehler aufgetreten!');
    return throwError(error);
  }
}
